import { render } from "./MovementView.vue?vue&type=template&id=fab121b6"
import script from "./MovementView.vue?vue&type=script&lang=js"
export * from "./MovementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__